import React from 'react';

const TrustLegal = () => {

  const trustPoints = [
    {
      id: 4,
      title: 'Privacy First',
      description: 'End-to-end encryption and minimal data collection. We never share personal information with third parties.',
      color: 'purple'
    },
    {
      id: 5,
      title: 'User Control',
      description: 'Participants can pause, stop, or exit any training session at any time. Full control over the learning experience.',
      color: 'blue'
    },
    {
      id: 6,
      title: 'Ethical AI',
      description: 'Our AI is designed to be helpful and educational, never deceptive or manipulative. Built on ethical principles.',
      color: 'green'
    }
  ];

  const getColorClasses = (color) => {
    const colorMap = {
      blue: {
        bg: 'bg-blue-500',
        text: 'text-blue-500',
        border: 'border-blue-500'
      },
      green: {
        bg: 'bg-green-500',
        text: 'text-green-500',
        border: 'border-green-500'
      },
      amber: {
        bg: 'bg-amber-500',
        text: 'text-amber-500',
        border: 'border-amber-500'
      },
      purple: {
        bg: 'bg-purple-500',
        text: 'text-purple-500',
        border: 'border-purple-500'
      }
    };
    return colorMap[color] || colorMap.blue;
  };

  return (
    <section className="py-8 bg-white relative overflow-hidden" id="trust-legal">
      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-xl p-8 border border-gray-200">
          <h3 className="text-xl font-semibold mb-6 font-sans">Ethical Training Principles</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {trustPoints.map((point) => {
              const colors = getColorClasses(point.color);
              return (
                <div key={point.id} className="bg-white rounded-lg p-6 border border-gray-200">
                  <h4 className="font-semibold mb-2 font-sans">{point.title}</h4>
                  <p className="text-slate-600 text-sm font-sans">{point.description}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-8 bg-white rounded-xl p-8 border border-gray-200">
          <h3 className="text-xl font-semibold mb-6 font-sans">Data Protection & Security</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold mb-3 font-sans">Technical Safeguards</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span className="text-slate-600 font-sans">End-to-end encryption for all data transmission</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span className="text-slate-600 font-sans">AES-256 encryption for data at rest</span>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-3 font-sans">Administrative Safeguards</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-slate-600 font-sans">Annual privacy impact assessments</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span className="text-slate-600 font-sans">Regular staff training on privacy protocols</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-slate-600 font-sans mb-4">Questions about our compliance and trust practices?</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <div className="flex items-center gap-2">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-slate-400">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
                <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span className="text-slate-600 font-sans">compliance@callsafe.training</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustLegal;
